<div class="login-wrapper" *ngIf="loginType === 'normal'">
  <div class="login-content">
    <h2 class="title">Welcome back</h2>
    <!-- <p class="subtitle"><a [routerLink]="['/sign-up']" class="sign-up">Sign up</a></p> -->
    <form [formGroup]="signInForm" class="login-form" (submit)="signInUser()">
      <div class="field-type-1">
        <label for="" class="field-label">Enter your email</label>
        <input type="email" formControlName="email" class="field-input" autocomplete="username" tabindex="1">
      </div>
      <div class="field-type-1">
        <label for="" class="field-label password-field">Enter your password</label>
        <input [type]="hidePassword ? 'password' : 'text'" class="field-input" formControlName="password" autocomplete="current-password" tabindex="2">
        <img [src]="hidePassword ? 'assets/images/view.svg' : 'assets/images/hide.svg'" alt="hide" class="show-password" (click)="showPasswordToggle()">
      </div>
      <button class="login-btn" type="submit" [disabled]="!signInForm.valid" tabindex="3">Log in</button>
    </form>
  </div>
</div>
